n<template>
    <div>
        <Loading :value="loading" ></Loading>
        <h3>Liste des employés</h3>
        <v-divider class="mb-2"></v-divider>
        <v-flex md12 class="mr-1">
          <div class="text-xs-right">
            <v-tooltip top>
              <v-btn
                  @click="newUser();loadService()"
                  slot="activator"
                  color="orange"
                  dark
              >
                  Employé
                  <v-icon right>add</v-icon>
              </v-btn> Ajouter un employé
              </v-tooltip>
               <v-tooltip top>
              <v-btn
                  @click="dialogListService = true;loadListService();loadUser()"
                  slot="activator"
                  color="primary"
                  dark
              >
                  Service
                  <v-icon right>list</v-icon>
              </v-btn> Liste des services
              </v-tooltip>
          </div>
      </v-flex>
        <el-form :inline="true" :model="formTri" class="demo-form-inline">
            <el-form-item label="Nom">
                <el-input clearable v-model="formTri.nom" placeholder="filtrer par nom" ></el-input>
            </el-form-item>

            <!--<el-form-item label="Prénom(s)">-->
                <!--<el-input v-model="formTri.prenom" placeholder="filtrer par prénom"   ></el-input>-->
            <!--</el-form-item>-->

            <el-form-item label="Service">
                <el-select filterable  clearable v-model="formTri.service" placeholder="filtrer par service">
                    <el-option
                            v-for="item in listeServices"
                            :key="item.id"
                            :label="item.libelle"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="Poste">
                <el-select clearable v-model="formTri.poste" placeholder="filtrer par poste occupé">
                    <el-option
                            v-for="item in listePostes"
                            :key="item.id"
                            :label="item.libelle"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="Contrat">
                <el-select clearable v-model="formTri.contrat" placeholder="filtrer par type contrat">
                    <el-option
                            v-for="item in listeTypeContrat"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>



            <el-form-item label="">
                <v-tooltip bottom>
                    <v-btn @click="rechercheUser()" slot="activator" class="white--text" color="blue" fab small :disabled="desactiveBout">
                        <v-icon>search</v-icon>
                    </v-btn>Effectuer une recherche
                </v-tooltip>
            </el-form-item>
        </el-form>

          <v-layout row wrap align-center >
              <v-flex xs12 md3 mb-3 pl-2 v-for="employSelect in listeEmployes">
                  <!--Modal detail employe-->
                  <modelCarteEmploye @close="closeListeEmp()"  @detailEmpl="showDetailEmploye"   :employe="employSelect" ></modelCarteEmploye>
                  <!--Modal detail employe-->
              </v-flex>
          </v-layout>



        <!--Modal detail employe-->
            <modalDetailEmploye   @close="showDetailEmpl = false" :show="showDetailEmpl" :userIdContrat="employSelect" ></modalDetailEmploye>
        <!--Modal detail employe-->


    <!-- MODAL AJOUT DE USER -->
    <v-dialog v-model="dialogAjout" max-width="80%" :overlay="true" scrollable persistent>
    	<v-card>
      	<v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title>
            <span >Ajouter un nouvel utilisateur</span>
          </v-toolbar-title>
        	<v-spacer></v-spacer>
        	<v-btn icon @click.native="dialogAjout = false" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

    	  <v-card-text v-loading="loading" element-loading-text="En cours d'enregistrement ..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
          <v-container fluid grid-list-md>
            <v-form v-model="valid" ref="formUser" lazy-validation id="formUser">
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content bg-purple">
                    <el-card class="box-card" style="background:#fff">
                      <div>

                        <v-flex xs12 sm4  class="text-xs-center">
                            <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4"> <img :src="logoUser" alt="avatar"></v-avatar><br/>
                            <input name="photo" type="file" style="display:none" ref="fileLogo" accept="image/*" @change="onFileImageLogoPicked"/>
                            <v-btn color="primary" class="white--text" required @click.native="$refs.fileLogo.click()">Photo  <v-icon right dark>cloud_upload</v-icon></v-btn><br/>
                            <!-- <div class="font-weight-thin" >Fichier au format (JPEG,PNG,PDF) avec une taille de 1048 ko maximale</div> -->
                        </v-flex>
                      </div>
                    </el-card>
                  </div>
                </el-col>
                <el-col :span="18" >
                  <div class="grid-content" style="padding:3px">
                    <el-row>
                      <el-col>
                        <div class="grid-content bg-purple">
                          <el-card class="box-card" style="background:#fff">
                            <v-layout row justify>
                              <v-flex md4>
                                <v-text-field label="Matricule" name="matricule" v-model="formUser.matricule" :rules="[(v) => !!v || 'Le Matricule est obligatoire']" required>
                                </v-text-field>
                              </v-flex>
                              <v-flex md4>
                                <v-text-field label="Nom et prénoms" name="nomUser" v-model="formUser.nomUser" :rules="nomUserRules" :counter="4" required>
                                </v-text-field>
                              </v-flex>
                              <v-flex md4>
                                <v-text-field label="E-mail" name="emailUser" v-model="formUser.emailUser" :rules="loginUserRules" :counter="6" required>
                                </v-text-field>
                              </v-flex>
                            </v-layout>

                            <v-layout row justify>
                                <!-- <v-flex md4>
                                <v-select  label="Type d'utilisateur" name="typeUser" v-bind:items="typeUser" v-model="selectTypeUser" :rules="[(v) => !!v || 'Veuillez sélectionner le type.']" item-value="value" item-text="text" ></v-select>
                              </v-flex> -->
                              <v-flex md4>
                                <v-text-field label="Fonction occupé" name="fonctionUser" v-model="formUser.fonctionUser" :counter="6" required></v-text-field>
                              </v-flex>
                              <v-flex md4>
                                <v-select label="Services" name="serviceUser" v-bind:items="listeServices" v-model="selectServiceUser" :rules="serviceUserRules" item-value="id" item-text="libelle" ></v-select>
                              </v-flex>
                            </v-layout>

                            <v-layout row justify>
                              <v-flex md4>
                                <v-select label="Genre" name="genre" v-bind:items="listCivilie" v-model="selectGenreUser" :rules="serviceCiviliteRules" item-value="value" item-text="text" ></v-select>
                              </v-flex>
                               <v-flex md4>
                                <v-text-field name="contactUser" min="0" label="Contact" v-model="formUser.contactUser" :counter="10" :rules="contactUserRules" hint="Exemple: 0900000055" persistent-hint required></v-text-field>
                              </v-flex>
                               <v-flex md4>
                                <v-text-field label="Adresse" name="adresse" v-model="formUser.adresse" :rules="[(v) => !!v || 'Adresse obligatoire']" required>
                                </v-text-field>
                              </v-flex>
                            </v-layout>
                          </el-card>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                  <br/>
                </el-col>
              </el-row>
            <v-flex md12 class="mr-1">
              <div class="text-xs-right">
                <v-btn @click="dialogAjout = false" color="error" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
                <v-btn icons color="blue" @click="submit" :disabled="!valid" dark>Enregistrer <v-icon right>save</v-icon></v-btn>
              </div>
            </v-flex>
            </v-form>
          </v-container>
    	  </v-card-text>
      	<div style="flex: 1 1 auto;"></div>
    	</v-card>
    </v-dialog>

    <!-- MODAL AJOUT DE SERVICE -->
    <v-dialog v-model="dialogService" max-width="50%" :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title>
            <span v-if="dialogEdit != true">Ajouter un nouveau service</span>
            <span v-if="dialogEdit">Modification du service {{serviceCourant.libelle}} </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogService = false" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text v-loading="loadingService" element-loading-text="En cours d'enrégistrement ..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
          <v-form v-model="valid" ref="formService" lazy-validation id="formService">
            <v-container fluid grid-list-md>
              <v-layout row justify>
                <v-flex md6>
                  <v-text-field label="Libellé" name="libelle" v-model="libelle" :rules="libelleRules" required></v-text-field>
                </v-flex>
                <v-flex md6>
                  <v-select label="Responsable de service" name="chef" v-bind:items="users" v-model="selectChef" :rules="chefRules" item-value="id" item-text="nom" chips required></v-select>
                </v-flex>
              </v-layout>
            </v-container>

            <v-btn @click="dialogService = false" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
            <v-btn icons color="blue" @click="submitService"  :disabled="!valid" dark>Enrregistrer <v-icon right>save</v-icon></v-btn>
          </v-form>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SHOW SERVICE -->
    <v-dialog v-model="dialogShow" max-width="50%" :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="indigo">
          <v-toolbar-title>Détails du service {{detailService.libelle}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogShow = false" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text v-loading="loading" element-loading-text="Veuillez patientez ..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
          <el-row :gutter="20">
            <div class="grid-content" style=" padding: 3px">
              <el-row>
                <el-card class="box-card">
                  <div class="grid-content bg-purple">
                    <div class="text item">
                      <v-layout row justify>
                        <v-flex md6>
                          <p><b>Identifiant : </b> {{detailService.id}} </p>
                          <p><b>Libellé : </b> {{detailService.libelle}} </p>
                          <p><b>Responsable de service : </b> {{detailService.chef}} </p>
                        </v-flex>
                        <v-flex md6>
                          <p><b>Date d'enrégistrement : </b> {{detailService.created}} </p>
                          <p><b>Date de modification : </b> {{detailService.modified}} </p>
                        </v-flex>
                      </v-layout>
                    </div>
                  </div>
                </el-card>
              </el-row>
            </div>
            <br/>
          </el-row>

          <v-tooltip top>
            <v-btn slot="activator" icons color="error" @click.stop="dialogShow = false" dark>Fermer <v-icon right>close</v-icon></v-btn>
            Fermer
          </v-tooltip>
          <v-tooltip top>
            <v-btn slot="activator" icons color="primary" @click.stop="editService(detailService);" dark>Modifier <v-icon right>edit</v-icon></v-btn>
            Modifier
          </v-tooltip>

        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>


  <v-dialog v-model="dialogListService"  max-width="90%" :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>Liste des services</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogListService = false" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text>
              <v-flex md12 class="mr-1">
                <div class="text-xs-right">
                  <v-tooltip top>
                    <v-btn
                        @click="newService()"
                        slot="activator"
                        color="orange"
                        dark
                    >
                        Service
                        <v-icon right>add</v-icon>
                    </v-btn> Ajouter un service
                    </v-tooltip>
                </div>
            </v-flex>


          <!-- LISTE SERVICES -->
           <el-row :gutter="20" v-loading="loading" element-loading-text="En cours d'enrégistrement ..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
              <v-container fluid grid-list-md>
                <el-card class="box-card">
                  <data-tables :data="listService" style="width: 100%">

                    <el-table-column prop="libelle" label="Libellé"></el-table-column>
                    <el-table-column prop="chef" label="Chef de service"></el-table-column>
                    <el-table-column label="Actions" fixed="right">
                      <template slot-scope="scope">
                        <v-btn
                          class="tooltip-btn"
                          title="Détails du service" 
                          icons
                          color="green" 
                          @click="showService(scope.row)"
                          fab dark small
                          > <v-icon>folder_open</v-icon>
                        </v-btn>
                        <v-btn
                        class="tooltip-btn"
                        title="Modifier le service" 
                        icons color="primary" 
                        @click="editService(scope.row)" 
                        fab dark small
                        > <v-icon>edit</v-icon>
                        </v-btn>
                      </template>
                    </el-table-column>
                  </data-tables>
                </el-card>
              </v-container>
            </el-row>
              <v-flex md12 class="mr-1">
                <div class="text-xs-right">
                  <v-tooltip top>
                    <v-btn slot="activator" icons color="error" @click.stop="dialogListService =false" dark>Fermer <v-icon right>close</v-icon></v-btn>
                    </v-tooltip>
                </div>
            </v-flex>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    </div>
</template>

<script>
    import Loading from '@/components/Loading';
    import modelCarteEmploye from '@/components/resourceHumaine/modelCarteEmploye'
    import modalDetailEmploye from '@/components/resourceHumaine/modalDetailEmploye'

    export default {
        props: {
          show: {
              type: Boolean
          }
        },
        components: {Loading,modelCarteEmploye,modalDetailEmploye},
        name: "listeEmploye",
        data(){
            return {
                domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
                user: JSON.parse(sessionStorage.getItem('userInfo')),


                listeEmployes:[],
                loading: false,
                dialogShow:false,
                dialogAjout: false,
                dialogService: false,
                dialogListService: false,
                dialogEdit: false,
                formUser:{
                  mUser: '',
                  matricule: '',
                  nomUser: '',
                  emailUser: '',
                  civilite:'',
                  contactUser: '',
                  fonctionUser: '',
                  adresse:''
                },
               logoUser: "/static/img-doc.png",

                selectTypeUser:'',
                  serviceUserRules: [
                    (v) => !!v || 'Veuillez sélectionner votre service.',
                  ],
                  serviceCiviliteRules:[
                    (v) => !!v || 'Veuillez sélectionner votre genre.',
                  ],
                  loginUserRules: [
                    (v) => !!v || 'Le E-mail est obligatoire',
                    (v) => /^\w+([.-]?\w+)*@\w+([-]?\w+)*(.\w{2,3})+$/.test(v) || 'Vous devez respecter format de E-mail'
                  ],
                  nomUserRules: [
                    (v) => !!v || 'Le nom est obligatoire',
                    (v) => v && v.length >= 4 || 'Vous devez renter pas moins de 4 caractères'
                  ],
                   contactUserRules: [
                      (v) => !!v || "Le contact de l'utilisateur est obligatoire",
                      (v) => /[0-9]/.test(v) || 'Vous devez respecter format du contact'
                    ],
                photo: '',
                loginUser: '',
                selectServiceUser: null,
                selectGenreUser: null,
                formTri: {},
                listeServices:[],
                listePostes: [],
                typeUser: [
                    { text: "Membre de l'entreprise", value: 1 },
                    //{ text: 'Representant de zone', value: 2 },
                  ],
                listCivilie: [
                  { text: "Masculin", value: 1 },
                  { text: 'Feminin', value: 2 },
                ],
                listeTypeContrat:[
                    {
                        label:"Stagiaire formation",
                        value: 1
                    },
                    {
                        label:"Stagiaire Professionnel",
                        value: 3
                    },
                    {
                        label:"Temps partiel",
                        value: 5
                    },
                    {
                        label:"Consultant",
                        value: 7
                    },
                    {
                        label: "CDI",
                        value: 9
                    },
                    {
                        label: "CDD",
                        value: 11
                    },
                ],
                users: [],
                valid: true,
                desactiveBout:false,
                employSelect: null,
                showDetailEmpl: false,
                loadingService: false,
                libelle: '',
                libelleRules: [ (v) => !!v || "Veuillez renseigner le libellé" ],
                selectChef: null,
                chef: '',
                chefRules: [ (v) => !!v || "Veuillez sélectionner le responsable du service" ],
                serviceCourant: [],
                detailService: [],
                listService: [],



            }
        },
        watch:{
            show: function(newValue, oldValue){
                if(newValue == true && this.listeEmployes.length == 0){
                    this.loadEmploye()
                }
            }
        },
        methods:{
            rechercheUser(){
                this.loading = true;
                this.listeEmployes = [];
                let url = this.domaine + 'userCreate/userbycritere';
                let data = {
                    nom: this.formTri.nom,
                    serviceId: this.formTri.service,
                    posteId: this.formTri.poste,
                    typeContrat :  this.formTri.contrat
                }

                this.$http.get(url,{params:data}).then(response => {
                    this.listeEmployes = response.body.listeUsers
                    this.loading = false
                }, err=>{
                    this.loading = false
                    this.$message.error("Chargement de la liste de recherche des employes, verifier votre connexion");
                })
            },
             submitService () {

        if (this.$refs.formService.validate()) {
            this.loadingService = true
          var form = document.getElementById('formService')
          var data = new FormData(form)
          data.append('idUser', this.user.id)
          data.append('chef', this.selectChef)
          let url = ''
          if (this.serviceCourant.id) {
            url = this.domaine + 'webService/'+ this.serviceCourant.id +'/edit/service'
          } else {
            url = this.domaine + 'webService/new/service'
          }
          this.$http.post(url, data).then(response => {
                  this.loadingService = false
            if (response.body) {

              let verif = response.body
              if (verif.code === 1) {
                if (this.serviceCourant.id) {
                  this.$notify({
                    title: 'MODIFICATION REUSSI',
                    message: 'Service modifié avec succès.',
                    type: 'success',
                    position: 'top-center'
                  })
                } else {
                  this.$notify({
                    title: 'ENREGISTREMENT REUSSI',
                    message: 'Service enregistré avec succès.',
                    type: 'success',
                    position: 'top-center'
                  })
                }
                this.dialogService = false
                this.dialogShow = false
                this.loadListService()
                this.loadingService = false
              } else if (verif.code === 0) {
                this.$message.error(verif.message)
                this.loadingService = false
              }
            } else {
              this.$message.error('Erreur serveur')
              this.loadingService = false
            }
          },
          response => {
            this.$message.error('Erreur serveur')
            this.loadingService = false
          })
        } else {
          this.$message.error('Veuillez renseigner les champs obligatoires')
          this.$notify.error({
            title: "ERREUR D'ENREGISTREMENT",
            message: "Le service n'a pas été enregistré.",
            position: 'top-center'
          })
          this.loadingService = false
        }
              },
             submit () {
                this.loading = true
                if (this.$refs.formUser.validate())
                {
                  //if (this.mdpUser === this.mdpVerUser)
                  //{
                    var form = document.getElementById('formUser')
                    var formdata = new FormData(form)
                    let url = ''
                    url = this.domaine + 'userCreate/new'
                    formdata.append('idUser', this.user.id)
                    formdata.append('serviceUser', this.selectServiceUser)
                    // formdata.append('fonctionUser', this.fonctionUser)
                    // formdata.append('type', this.selectTypeUser)
                    // formdata.append('nomUser', this.formUser.nomUser)
                    // formdata.append('contactUser', this.formUser.contactUser)
                    formdata.append('genre', this.selectGenreUser)
                    // formdata.append('matricule', this.formUser.matricule)
                    // formdata.append('emailUser', this.formUser.emailUser)
                    // formdata.append('adresse', this.formUser.adresse)
                    formdata.append('rh', "oui")
                    formdata.append('poste', null)

                    this.$http.post(url, formdata).then(response => {
                      if (response.body) {
                        let verif = response.body
                         this.loading = false
                          this.dialogAjout = false
                          if (verif.code === 2) {
                            this.$notify({
                              title: "L'UTILISATEUR A BIEN ETE AJOUTE",
                              message: verif.message,
                              type: 'success',
                              position: 'top-center'
                            })

                          // this.loadUser()
                        } else{
                           this.$notify({
                              title: "L'UTILISATEUR EXISTE DEJA",
                              message: verif.message,
                              type: 'error',
                              position: 'top-center'
                            })
                        }

                      }
                    },
                    error => {
                      this.$message.error('Erreur serveur')
                      this.loading = false
                    })
                  //} else {
                    //this.$message.error('Le mot de passe de vérification doit être identique au mot de passe')
                  //}
                } else {
                  this.$message.error('Veuillez renseigner les champs obligatoires')
                  this.$notify.error({
                    title: "ERREUR D'ENREGISTREMENT",
                    message: "Utilisateur n'a pas été enregistré.",
                    position: 'top-center'
                  })
                  this.loading = false
                }
              },
                editService (ligne) {
                    this.serviceCourant = ligne
                    this.dialogService = true
                    this.dialogEdit = true
                    this.libelle = this.serviceCourant.libelle
                    this.selectChef = this.serviceCourant.idChef
                  },
              showService (ligne) {
                this.dialogShow = true
                this.serviceCourant = ligne
                let url = this.domaine + 'webService/'+ this.serviceCourant.id +'/show/service'
                this.$http.get(url).then(response => {
                  if (response.body) {
                    this.detailService = response.body.service
                  }
                })
              },
            //enregistrement des images
            onFileImageLogoPicked(event)
            {
                const files = event.target.files
                let filename = files[0].name
                if (filename.lastIndexOf(".") <= 0)
                {
                    return alert("Veuillez selectionner un  format de fichier valide ")
                }

                const fileReader = new FileReader()
                fileReader.addEventListener("load", () => {
                    this.logoUser = fileReader.result
                })

                fileReader.readAsDataURL(files[0])
                this.logoUser = files[0]

            },

            newUser() {
               this.dialogAjout = true
                this.formUser = {}
                this.selectServiceUser = null
                this.selectTypeUser = null
                this.selectGenreUser = null
                this.logoUser = "/static/img-doc.png";
            },
            closeListeEmp(){
                this.$emit("close");
            },
            showDetailEmploye(idEmploye){
                this.employSelect = idEmploye
                this.showDetailEmpl = true
            },
            loadEmploye(){
                let url = this.domaine+"rh/employes";
                this.loading = true;
                this.$http.get(url).then(resp =>{
                    this.loading = false;
                    this.listeEmployes = resp.body.listeEmployes;
                }, error =>{
                    this.loading = false;
                    this.$message.error("Echec lors du chargement de la liste des employés")
                });

            },
             loadListService () {
              let url = this.domaine + 'webService/liste-service'
              this.$http.get(url).then(response => {
                if (response.body) {
                  this.listService = response.body.service
                }
              })
            },
            loadUser () {
                  let url = this.domaine + 'userCreate/user-list'
                  this.$http.get(url).then(response => {
                    if (response.body) {
                      this.users = response.body
                    }
                  })
                },
            newService() {
                this.dialogService = true
                this.dialogEdit = false
                this.libelle = ""
                this.selectChef = ""
            },
            loadService(){
                let url = this.domaine+"userCreate/liste/service";
                this.loading = true;
                this.$http.get(url).then(resp =>{
                    this.loading = false;
                    this.listeServices = resp.body.listeServices;

                }, error =>{
                    this.loading = false;
                    this.$message.error("Echec lors du chargement de la liste des services")
                });
            },

            loadPoste(){
                let url = this.domaine+"rh/liste/poste";
                this.loading = true;
                this.$http.get(url).then(resp =>{
                    this.loading = false;
                    this.listePostes= resp.body.listePostes;
                }, error =>{
                    this.loading = false;
                    this.$message.error("Echec lors du chargement de la liste des postes")
                });
            }
        },
        mounted(){
            this.loadPoste();
            // this.loadService();
        }
    }

</script>

<style>
    .el-tabs--border-card
    {
        background: #FAFAFA;
    }

    .tooltip-btn {
    position: relative;
    background-color: grey;
    color: white;
  }

  .tooltip-btn::after {
    content: attr(title);
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    padding: 5px;
    border-radius: 5px;
    white-space: nowrap;
    opacity: 0;
    visibility: hidden;
    color: white;
    transition: opacity 0.9s, visibility 0.9s;
  }

  .tooltip-btn:hover::after {
    opacity: 1;
    visibility: visible;
  }
</style>



// WEBPACK FOOTER //
// src/components/resourceHumaine/liste_employe.vue